"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditableListDialog = void 0;
var editablelist_1 = require("./editablelist");
var mobx_react_1 = require("mobx-react");
var React = require("react");
var dialog_1 = require("../dialog");
var utils_1 = require("../../utils");
var EditableListDialog = (function (_super) {
    __extends(EditableListDialog, _super);
    function EditableListDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.rowClickHandler = function (e, id_) {
            (0, utils_1.preventDefault)(e);
            var anchor = e.currentTarget.href ?
                e.currentTarget :
                $(e.currentTarget).children().find("a")[0];
            if (anchor) {
                window.open(anchor.href, '_blank');
            }
            else {
                console.error("Link not found.");
            }
        };
        _this.headerClickHandler = function (e) {
            (0, utils_1.preventDefault)(e);
        };
        return _this;
    }
    EditableListDialog.prototype.render = function () {
        var props = this.props;
        return (React.createElement(dialog_1.Dialog, { isOpen: props.isOpen, isReady: props.isReady, contentLabel: props.dialogHeader, shouldCloseOnOverlayClick: true, onClose: props.onDialogClose },
            React.createElement("div", { className: "Dialog__ScrollWrapper" },
                React.createElement(editablelist_1.EditableList, __assign({ rowClickHandler: this.rowClickHandler, headerSortClickHandler: this.headerClickHandler }, props, { disableResizeToPage: true })))));
    };
    EditableListDialog = __decorate([
        mobx_react_1.observer
    ], EditableListDialog);
    return EditableListDialog;
}(React.Component));
exports.EditableListDialog = EditableListDialog;
